(function () {
  function initCarousel(root) {
    if (!root || root.dataset.mukCarouselReady === 'true') return;
    var track = root.querySelector('[data-muk-carousel-track]');
    var prev = root.querySelector('[data-muk-carousel-prev]');
    var next = root.querySelector('[data-muk-carousel-next]');
    if (!track || !prev || !next) return;

    root.dataset.mukCarouselReady = 'true';

    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      root.classList.toggle('muk-xd-carousel--no-scroll', max <= 2);
    }

    function move(direction) {
      var first = track.firstElementChild;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      var amount = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    if (window.MutationObserver) {
      new MutationObserver(function () { window.requestAnimationFrame(update); window.setTimeout(update, 80); }).observe(track, { childList: true, subtree: false });
    }

    root._mukCarouselUpdate = update;
    window.requestAnimationFrame(update);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-muk-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var carousel = event.target && event.target.closest ? event.target.closest('[data-muk-carousel]') : null;
    if (carousel) { initCarousel(carousel); if (carousel._mukCarouselUpdate) carousel._mukCarouselUpdate(); }
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-muk-home-tab]')) return;
    window.setTimeout(function () {
      document.querySelectorAll('[data-muk-carousel]').forEach(function (carousel) {
        if (carousel._mukCarouselUpdate) carousel._mukCarouselUpdate();
      });
    }, 40);
  });
})();
